import React from 'react';
import DataResource from './../../../common/v4/DataResource';
import Panel from './../../../common/layout/Panel';
import Tabs from './../../../common/Tabs';

const tabs = [
    {
        link: '/clients/companies',
        name: 'Companies'
    },
    {
        link: '/clients/branches',
        name: 'Branches'
    },
    {
        link: '/clients/teams',
        name: 'Teams'
    }
] 

const CompaniesIndex = (props) => {
    const data = {
        url: '/admin/clients/companies',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/clients/companies/{id}',
        userfilter: [
            {
                source: 'name',
                label: 'Name',
                type: 'text',
                default: ''
            }
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: true,
                default: '',
                placeholder: 'Company Name'
            },
            {
                label: 'Franchise',
                source: 'franchise_id',
                type: 'select'
            },
            {
                label: 'Address',
                source: 'address',
                type: 'text',
                editable: true,
                default: '',
                placeholder: 'Address'
            },
            {
                label: 'City',
                source: 'city',
                type: 'text',
                editable: true,
                default: '',
                placeholder: 'City'
            },
            {
                label: 'State',
                source: 'state',
                type: 'text',
                editable: true,
                default: '',
                placeholder: 'State'
            },
            {
                label: 'Created',
                source: 'created_at',
                type: 'datetime',
                editable: false,
                visible: true
            },
            
            {
                label: 'Enabled',
                source: 'status',
                type: 'boolean',
                editable: true,
                default: true
                }, 
            {
                label: 'Delete',
                type: 'delete'
            }
        ]
    };
    return (
        <Panel title="Companies">
            <div>
                <Tabs tabs={tabs} />
                <DataResource
                    data={data}
                    addButtonText="Create Company"
                    addButtonLink="/clients/companies/create"
                    {...props}
                />
            </div>
        </Panel>
    );
};

export default CompaniesIndex; 